export default {
    getDListInternals: (state) => state.dListInternal,
  }